angular.module('app').factory('GatewayFactory',[
    'Restangular',
    'LoginFactory',
    'LocalStorageRepository',
    'configuration',
    '$q',
    '$qHelpers',
    'aprgettext',
    function (
        Restangular,
        LoginFactory,
        LocalStorageRepository,
        configuration,
        $q,
        $qHelpers,
        gettext
        ) {
            'use strict';

            var gateways = _(configuration.GATEWAYS).map(function (gateway) {
                var restangular = Restangular.withConfig(function () {
                });

                restangular.setBaseUrl(gateway.url);
                restangular.setDefaultHeaders({
                    'ApiKey': configuration.API_KEY
                });

                return {
                    prefix: gateway.prefix,
                    restangular: restangular
                };
            });

            function getServerUrl(clientId, gatewayPrefix) {
                var clientUrl = LocalStorageRepository.getClientURL();
//                var clientUrl = 'http://MobileAppService:8000';
//                LocalStorageRepository.setClientURL(clientUrl);

                if (clientUrl) {
                    var deferred = $q.defer();
                    deferred.resolve(clientUrl);
                    return deferred.promise;
                }
                else {
                    var filteredGateways = gateways;

                    if (gatewayPrefix) {
                        filteredGateways = filteredGateways.filter(function (gateway) {
                            return gateway.prefix === gatewayPrefix;
                        });

                        if (!filteredGateways.some()) {
                            return $q.reject(new Error(gettext('Gateway prefix is not recognized.')));
                        }
                    }

                    var gatewayRequests = filteredGateways.map(function (gateway) {
                        return gateway.restangular.one('home', clientId).get();
                    }).map(function (promise) {
                        return $qHelpers.timeout(promise, 5000);
                    }).value();

                    return $qHelpers
                        .whenFirstSuccess(gatewayRequests)
                        .then(function (serverInfo) {
                            LocalStorageRepository.setClientURL(serverInfo.AppServerUrl);
                            return serverInfo.AppServerUrl;
                        }, function (response) {
                            return $q.reject(new Error(gettext('Gateway connection error') + ' (' + response.status + ')'));
                        });
                }
            }

            function login(clientId, username, password, gatewayPrefix, userId) {
                if (!configuration.DEV_HOSTED) {
                    var url = LocalStorageRepository.getClientURL();
                    return loginWithUrl(url);
                }

                return getServerUrl(clientId, gatewayPrefix)
                        .then(loginWithUrl);
                    
                function loginWithUrl(url) {
                    LocalStorageRepository.clearAll();
                    LocalStorageRepository.setClientURL(url);
                    LocalStorageRepository.setClientID(clientId);
                    return LoginFactory.postLogin(url, clientId, username, password, userId, configuration.CLIENT_FEATURES);
                }
            }

            return {
                login: login
            };
        }]);

